import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create(
{
    page: {
        width: '90%',
        alignSelf: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        padding: 20
    },

    columns: {
        flex: 1,
        flexDirection: 'row' ,
        width: '100%',
    },

    oneColumn: {
        flex: 1,
        flexDirection: 'column',
        width: '100%',
    },

    column: {
        width: '70%',
        marginRight: '2%',
    },

    columnLeft: {
        flexDirection: 'column',
        width: '66%',
    },

    columnRight: {
        position: "absolute",
        right: 0
    },

});